export const storageKeys = {
  token: 'token',
  user: 'user-data',
};
